import styles from './CourseAssignment.module.scss';
import { isNil } from '../../../../lib/utils/isNil';
import { Api } from '../../../../lib/types/apiSpec';

export const renderUser = ({ firstName, lastName, email, city, state }: Api.UserSearch) => (
  <div className={styles.nurseItem}>
    <div className={styles.userDetails}>
      <span className={styles.userName}>{`${firstName} ${lastName}`}</span>
      <span className={styles.userEmail}>{email}</span>
    </div>
    <div className={styles.userCity}>{city && state ? `${city}, ${state}` : city || state}</div>
  </div>
);

export const userIdFn = (user: Api.UserSearch) => user.userId;
export const filterUsers =
  (phrase: string) =>
  ({ firstName, lastName }: Api.UserSearch) => {
    if (!phrase) {
      return true;
    }
    const phrases = phrase.split(' ');

    return phrases.some(
      phraseItem =>
        firstName.toLowerCase().includes(phraseItem.toLowerCase()) ||
        lastName?.toLowerCase().includes(phraseItem.toLowerCase()),
    );
  };

export const isUser = (value: any): value is Api.UserSearch => !isNil(value.userId);
